module.exports = __webpack_public_path__ + "static/media/img-message-reason@2x.a254097d.png";